<template>
  <div>
    <div class="bottom">
      <div class="bottom_box">
        <div class="item_box">
          <a href="bottom_detail.html?type=1" class="bottom_item" >本站公告</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=termsOfservice')">服务条款</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=privacyClause')">隐私条款</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=memberServices')">会员服务</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=advertisingServices')">广告服务</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=aboutUs')">关于我们</a>
          <a class="bottom_item" @click="jump('bottom_detail?type=2&name=contactUs')">联系我们</a>
        </div>
        <div style="flex: 1;">
          <div class="items">
            <div v-if="type == 1">
              <el-table ref="filterTable" :data="list" style="width: 100%" :row-class-name="tableRowClassName"
                :header-cell-style="{ 'background-color': 'rgba(32, 137, 255, 0.2)', color: '#2089FF', 'font-weight': '500' }"
                @row-click="rowClick">
                <el-table-column prop="category.name" label="公告类型" width="180"></el-table-column>
                <el-table-column prop="title" label="公告标题"></el-table-column>
                <!-- <el-table-column prop="noticeFirm" label="发布企业"></el-table-column> -->
                <el-table-column prop="createTime" label="发布时间" width="200">
                  <template slot-scope="scope">{{ $dy_tool.formatDate(scope.row.createTime) }}</template>
                </el-table-column>
              </el-table>
              <div style="padding:0.833vw 0 6.25vw;text-align:right;">
                <el-pagination @current-change="topChange" @prev-click="prevClick" @next-click="nextClick" :page-size="10"
                  layout="prev, pager, next, jumper" :total="total">
                </el-pagination>
              </div>
            </div>
            <div v-if="type == 2">
              <div v-if="name == 'termsOfservice'" class="borderLeft">服务 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">条款</span> </div>
              <div v-if="name == 'aboutUs'" class="borderLeft">关于 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">我们</span> </div>
              <div v-if="name == 'advertisingServices'" class="borderLeft">广告 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">服务</span> </div>
              <div v-if="name == 'memberServices'" class="borderLeft">会员 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">服务</span> </div>
              <div v-if="name == 'contactUs'" class="borderLeft">联系 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">我们</span> </div>
              <div v-if="name == 'privacyClause'" class="borderLeft">隐私 <span
                  style="font-size:24px;color:#2089ff;margin-left:4px">条款</span> </div>
              <div class="item_info">
                <div v-html="detail"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <tab-bottom ref="bottom"></tab-bottom>
    </div>
    
  </div>
</template>

<script>

import adver from '@/pages/advertisement.vue';
import BaseMixin from '@/mixins/BaseMixin.vue';
import PageMixin from '@/mixins/PageMixin.vue';
import tabBottom from '@/pages/bottom.vue'
export default {
  mixins: [BaseMixin, PageMixin],
  data() {
    return {
      type: 1,
      name: '',
      detail: '',
      total: 0
    }
  },
  components: {
    tabBottom,
    adver
  },
  methods: {
    initData() {
      this.type = this.pageParams.type
      this.name = this.pageParams.name
      if (this.pageParams.type == 1) {
        this.searchForm.type = 0
        this.pageApi = this.$u.api.articleList
        this.initList()
      }
      this.$u.api.configSym({ keyStr: 'termsOfservice,aboutUs,advertisingServices,memberServices,contactUs,privacyClause' }).then(res => {
        for (let key in res.data) {
          console.log(this.pageParams.name);
          if (this.pageParams.name == key) {
            this.detail = res.data[key]
            console.log(key);
          }
        }
        console.log(res);
      })

    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);

      if (rowIndex % 2 == 0) {
        // console.log(row)
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    rowClick(row) {
      console.log(row);
      this.jump('notice_detail?id=' + row.id)
    },

    topChange(e) {
      this.currentPage.page = e - 1
      this.getList()
    },
    prevClick(e) {
      this.currentPage.page = e + 1
      this.getList()
    },
    nextClick(e) {
      this.currentPage.page = e - 1
      this.getList()
    },
  }
}
</script>
<style>
page {
  background: none;
}
</style>
<style lang="less" scoped>
.bottom {
  margin: 0  auto; width:68.5vw; /* 边距 */
  background: #fff;
  padding-top: 30px;

  .bottom_box {
    display: flex;

    .item_box {
      min-width: 260px;
      padding: 0 20px;

      .bottom_item {
        cursor: pointer;
        margin: 0 auto;
        width: 172px;
        margin-bottom: 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 10px;
        color: #fff;
        background-color: #2089ff;
        text-align: center;
      }
    }

    .items {
      margin-top: 10px;
      padding-right: 50px;

      .borderLeft {
        border-left: 0.208vw solid #2089ff;
        font-size: 1.04vw;
        color: #333;
        font-weight: 500;
        padding: 0 0 0 0.52vw;
        margin: 0;
        line-height: 1.04vw;
      }

      .item_info {
        margin-top: 20px;
      }
    }
  }
}
</style>
